import React from 'react';
import styled from 'styled-components';

/**
 * Schedule section rendering the timetable iframe.
 */
const ScheduleSection = styled.section`
  padding: ${({ theme }) => `${theme.spacing['2xl']} 0`};
  background-color: ${({ theme }) => theme.colors.white};
`;

const ScheduleContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.lg};

  h2 {
    margin-bottom: 1.5rem;
    color: ${({ theme }) => theme.colors.dark};
  }
`;

const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 ratio */
  background: ${({ theme }) => theme.colors.light};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
`;

const StyledIframe = styled.iframe`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

const Schedule: React.FC = () => {
  return (
    <ScheduleSection id="grafik" className="section">
      <ScheduleContainer>
        <h2>Grafik</h2>
        <IframeWrapper>
          <StyledIframe
            src="https://adara.swiplo.com.pl/plan-zajec/sala-cappuccino-ul-elektronowa-2-zielona-gora"
            title="Plan zajęć"
            loading="lazy"
          />
        </IframeWrapper>
      </ScheduleContainer>
    </ScheduleSection>
  );
};

export default Schedule;
